import { render, staticRenderFns } from "./CopyrightAmendmentDetailsMessages.vue?vue&type=template&id=2354b6b2&scoped=true&"
import script from "./CopyrightAmendmentDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354b6b2",
  null
  
)

export default component.exports